// Body-free head projection for Learn articles, read by RouteMetadata on the
// client and by the prerender script through the SSR bundle, so both writers
// emit the same article tags from the same catalog fields.
import { LEARN_CATALOG, type LearnCatalogEntry } from './catalog';
import { isLearnPublished, learnSlugFromPath } from './publication';

export interface LearnArticleHead {
  publishedOn: string;
  updatedOn: string;
  ogType: 'article';
}

/**
 * The projection follows the rule RouteMetadata already applies to held
 * routes: a held article resolves in development (the review surface) and
 * never in production. Without both dates there is nothing truthful to write.
 */
export function projectLearnHead(input: { entry: LearnCatalogEntry; published: boolean; dev: boolean }): LearnArticleHead | null {
  const { entry, published, dev } = input;
  if (!published && !dev) return null;
  if (!entry.publishedOn || !entry.updatedOn) return null;
  return { publishedOn: entry.publishedOn, updatedOn: entry.updatedOn, ogType: 'article' };
}

/** Null for the index, unknown Learn paths, non-Learn paths and production holds. */
export function learnHeadData(pathname: string, options: { dev?: boolean } = {}): LearnArticleHead | null {
  const slug = learnSlugFromPath(pathname);
  if (!slug) return null;
  const entry = LEARN_CATALOG.find(candidate => candidate.slug === slug);
  if (!entry) return null;
  return projectLearnHead({ entry, published: isLearnPublished(slug), dev: options.dev === true });
}
